module.exports = __webpack_public_path__ + "static/alster-82b2f639be3d22c4ec2fff486999ad0e.png";